import React, { useEffect, useState } from "react";
import FireOnMenu from "./FireOnMenu";
import DashboardMenu from "./DashboardMenu";
import { useLocation, useParams } from "react-router-dom";
import { connectRealtimeDashboardWebSocket } from "../../websock/realtimeDashboardManager";
import { dateFormat, getDateTime, getTime } from "../../utils/date";
import PageHeader from "../PageHeader";

export default function FireEventLogComponent() {
  const { id } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [actionList, setActionList] = useState([]);

  useEffect(() => {
    connectRealtimeDashboardWebSocket(id, (data) => {
      setActionList(data.actionList);
    });
  }, []);

  return (
    <section id="darkMode" class="mbSection darkMode">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      <div class="container">
        <p class="tableTitle">동작로그</p>
        <div class="tableList opLoglist">
          <div class="config-row title-row">
            <div class="title-txt config-date">발생일시</div>
            <div class="title-txt config-event">이벤트명</div>
            <div class="title-txt config-location">동작위치</div>
          </div>
          <div class="config-row-wrap scroll-wrap type-273">
            {actionList.length > 0 &&
              actionList.map((item, index) => (
                <div class="config-row">
                  <div class="config-date">
                    <p class="date-title">{dateFormat(new Date(item.time))}</p>
                    <p class="time-title">{getTime(new Date(item.time))}</p>
                  </div>
                  <div class="config-event">
                    <p class="event-title">{item.eventName}</p>
                  </div>
                  <div class="config-location">
                    <p class="location-title">{item.actionLocation}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div id="dashboardMenu" class="active_01">
        <DashboardMenu buildingName={buildingName} />
      </div>
      <FireOnMenu />
    </section>
  );
}
